import React from "react";
import type { FC } from "react";

import { useFavouriteState } from "./FavouriteProvider.state";
import { FavouriteProviderContext } from "./FavouriteProvider.context";
import { IFavouriteProviderProps } from "./FavouriteProvider.types";

const FavouriteProviderContextProvider = FavouriteProviderContext.Provider;

const FavouriteProvider: FC<IFavouriteProviderProps> = (props) => {
  const { children } = props;

  const state = useFavouriteState(props);

  return <FavouriteProviderContextProvider value={state}>{children}</FavouriteProviderContextProvider>;
};

export { FavouriteProvider };
